import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})

export class ExpenseService {

  constructor(private readonly http: HttpClient) { }

  getExpenseCategory(params: any) {
    let url = environment.BASE_URL + '/v1/category/list-with-count';
    return this.http.get(url, { params: params });
  }

  createExpenseCategory(payload: any) {
    let url = environment.BASE_URL + '/v1/category';
    return this.http.post(url, payload);
  }

  updateExpenseCategory(id: string, payload: any) {
    let url = environment.BASE_URL + `/v1/category/${id}`;
    return this.http.put(url, payload);
  }

  getExpenseList(params: any) {
    let url = environment.BASE_URL + '/v1/expense';
    return this.http.get(url, { params: params });
  }

  getAllCategories(params: any) {
    let url = environment.BASE_URL + '/v1/category';
    return this.http.get(url, { params: params });
  }

  getExpanseHighlights(params: any) {
    let url = environment.BASE_URL + '/v1/expense/summary-cards';
    return this.http.get(url, { params: params });
  }

  createExpense(payload: any) {
    let url = environment.BASE_URL + '/v1/expense';
    return this.http.post(url, payload);
  }

  updateExpense(id: string, payload: any) {
    let url = environment.BASE_URL + `/v1/expense/${id}`;
    return this.http.put(url, payload);
  }

  deleteExpense(id: string) {
    let url = environment.BASE_URL + `/v1/expense/${id}`;
    return this.http.delete(url);
  }

}
